<style>
@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Accounts" title="User Pending Dues" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
							<div class="row mb-3">
								<div class="col-12">
									<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end">
										<i class="bx bx-chevrons-left"></i> Back
									</a>
								</div>
							</div>

							<div class="row mb-3" v-if="user_id">
								<div class="col-md-12">
									<div class="alert alert-light border d-flex flex-wrap gap-4 mb-0 align-items-center">
										<div v-if="summaryPaymentUserType != null && summaryPaymentUserType !== ''">
											<strong>Type:</strong>
											<span class="badge rounded-pill bg-info text-dark ms-1" v-if="summaryPaymentUserType == 1">Dealer</span>
											<span class="badge rounded-pill bg-secondary ms-1" v-else-if="summaryPaymentUserType == 2">Customer</span>
											<span class="badge rounded-pill bg-light text-dark ms-1" v-else>—</span>
										</div>
                                        <div v-if="summaryUserName">
											<strong>Name:</strong> {{ summaryUserName }}
										</div>
										<div>
											<strong>Total renewal pending:</strong>
											<span class="text-danger fw-bold">₹{{ formatMoney(totalRenewalPendingAmount) }}</span>
										</div>
										<div>
											<strong>Total service pending:</strong>
											<span class="text-warning fw-bold">₹{{ formatMoney(totalServicePendingAmount) }}</span>
										</div>
									</div>
								</div>
							</div>

							<!-- Renewal pending -->
							<div class="card border mb-4">
								<div class="card-header bg-warning">
									<strong>Renewal pending payments</strong>
								</div>
								<div class="card-body">
                                    <div class="col-md-12 project-list filter-sort">
                                        <div class="row align-items-end mb-3">
                                            <div class="col-md-8 d-flex">
                                                <label class="d-flex listing-length ms-1 align-items-center">
                                                    <span class="me-2">Show</span>
                                                    <select class="form-select mx-1" style="width: auto" v-model.number="renewal_limit" @change="onRenewalLimitChange">
                                                        <option :value="5">5</option>
                                                        <option :value="10">10</option>
                                                        <option :value="20">20</option>
                                                    </select>
                                                    <span class="ms-1">entries</span>
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Search renewal (IMEI, vehicle, payment id…)"
                                                    v-model="renewal_keyword"
                                                    @keyup="debouncedFetchRenewal"
                                                />
                                            </div>
                                        </div>
                                    </div>

									<div class="table-responsive">
										<table class="table table-sm display">
											<thead>
												<tr align="center">
													<th>Sl</th>
													<th>IMEI & Vehicle</th>
													<th>Date</th>
													<th>Work amt</th>
													<th>Pending</th>
													<th>Status</th>
													<th>Type</th>
													<th>Action</th>
												</tr>
											</thead>
											<tbody v-if="renewalRows.length">
												<tr align="center" v-for="(row, index) in renewalRows" :key="'r-' + row.id">
													<td>{{ renewalFrom != null ? renewalFrom + index : index + 1 }}</td>
													<td class="text-start">{{ row.imei || "—" }}<br>
													    {{ row.vehicle_no || "—" }}
                                                    </td>
													<td>{{ row.payment_date || "—" }}</td>
													<td>₹{{ formatMoney(row.amount) }}</td>
													<td class="text-danger">₹{{ formatMoney(row.balance_amount) }}</td>
													<td>
														<span class="badge rounded-pill bg-info text-dark" v-if="row.payment_status == 1">Received</span>
														<span class="badge rounded-pill bg-warning text-dark" v-else-if="row.payment_status == 2">Pending</span>
														<span class="badge rounded-pill bg-info text-dark" v-else-if="row.payment_status == 3">Partially</span>
														<span class="badge rounded-pill bg-secondary text-dark" v-else-if="row.payment_status == 4">Credit</span>
													</td>
													<td>
														<span class="badge rounded-pill bg-info text-dark" v-if="row.payment_type == 1">Received</span>
														<span class="badge rounded-pill bg-warning text-dark" v-else-if="row.payment_type == 2">Pending</span>
														<span class="badge rounded-pill bg-info text-dark" v-else-if="row.payment_type == 3">Partially</span>
														<span class="badge rounded-pill bg-secondary text-dark" v-else-if="row.payment_type == 4">Credit</span>
														<span class="badge rounded-pill bg-warning text-dark" v-else>—</span>
													</td>
													<td>
                                                        
                                                    </td>
												</tr>
											</tbody>
											<tbody v-else>
												<tr>
													<td colspan="11" class="text-center text-muted">No renewal pending payments</td>
												</tr>
											</tbody>
										</table>
									</div>

									<caption v-if="renewalRows.length" class="float-start mt-2 d-block text-muted small">
										Showing {{ renewalFrom }} to {{ renewalTo }} of {{ renewalTotal }} entries
									</caption>
									<nav v-if="renewalRows.length && renewalPagination.length" class="mt-2 float-end">
										<ul class="pagination pagination-sm mb-0">
											<li
												class="page-item"
												v-bind:class="[{ disabled: !p.url }, { active: p.active }]"
												v-for="(p, idx) in renewalPagination"
												:key="'rp-' + idx"
											>
												<a class="page-link" href="#" @click.prevent="onRenewalPageClick(p)">
													<span v-if="idx === 0">Prev</span>
													<span v-else-if="idx === renewalPagination.length - 1">Next</span>
													<span v-else>{{ p.label }}</span>
												</a>
											</li>
										</ul>
									</nav>
								</div>
							</div>

							<!-- Service pending -->
							<div class="card border">
								<div class="card-header bg-secondary">
									<strong>Service / work pending payments</strong>
								</div>
								<div class="card-body">
                                    <div class="col-md-12 project-list filter-sort">
                                        <div class="row align-items-end mb-3">
                                            <div class="col-md-8 d-flex">
                                                <label class="d-flex listing-length ms-1 align-items-center">
                                                    <span class="me-2">Show</span>
                                                    <select class="form-select mx-1" style="width: auto" v-model.number="service_limit" @change="onServiceLimitChange">
                                                        <option :value="5">5</option>
                                                        <option :value="10">10</option>
                                                        <option :value="20">20</option>
                                                    </select>
                                                    <span class="ms-1">entries</span>
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Search service pending…"
                                                    v-model="service_keyword"
                                                    @keyup="debouncedFetchService"
                                                />
                                            </div>
                                        </div>
                                    </div>

									<div class="table-responsive">
										<table class="table table-sm display">
											<thead>
												<tr align="center">
													<th>Sl</th>
													<th>IMEI</th>
													<th>Vehicle</th>
													<th>Date</th>
													<th>Work amt</th>
													<th>Pending</th>
													<th>Payment Status</th>
													<th>Type</th>
													<th>Service #</th>
												</tr>
											</thead>
											<tbody v-if="serviceRows.length">
												<tr align="center" v-for="(row, index) in serviceRows" :key="'s-' + row.id">
													<td>{{ serviceFrom != null ? serviceFrom + index : index + 1 }}</td>
													<td class="text-start">{{ row.imei || "—" }}</td>
													<td>{{ row.vehicle_no || "—" }}</td>
													<td>{{ row.payment_date || "—" }}</td>
													<td>₹{{ formatMoney(row.work_amount) }}</td>
													<td class="text-danger">₹{{ formatMoney(row.pending_amount) }}</td>
													<!-- <td class="fw-bold">₹{{ formatMoney(row.balance_amount) }}</td> -->
													<td>
														<span class="badge rounded-pill bg-info text-dark" v-if="row.payment_status == 1">Received</span>
														<span class="badge rounded-pill bg-warning text-dark" v-else-if="row.payment_status == 2">Pending</span>
														<span class="badge rounded-pill bg-info text-dark" v-else-if="row.payment_status == 3">Partially</span>
														<span class="badge rounded-pill bg-secondary text-dark" v-else-if="row.payment_status == 4">Credit</span>
													</td>
													<td>
														<span class="badge rounded-pill bg-info text-dark" v-if="row.payment_type == 1">Received</span>
														<span class="badge rounded-pill bg-warning text-dark" v-else-if="row.payment_type == 2">Pending</span>
														<span class="badge rounded-pill bg-info text-dark" v-else-if="row.payment_type == 3">Partially</span>
														<span class="badge rounded-pill bg-secondary text-dark" v-else-if="row.payment_type == 4">Credit</span>
													</td>
													<!-- <td>
														<span class="badge rounded-pill" :class="paymentStatusClass(row.payment_status)">
															{{ paymentStatusLabel(row.payment_status) }}
														</span>
													</td> -->
													<td>{{ row.work_service_id || "—" }}</td>
												</tr>
											</tbody>
											<tbody v-else>
												<tr>
													<td colspan="10" class="text-center text-muted">No service pending payments</td>
												</tr>
											</tbody>
										</table>
									</div>

									<caption v-if="serviceRows.length" class="float-start mt-2 d-block text-muted small">
										Showing {{ serviceFrom }} to {{ serviceTo }} of {{ serviceTotal }} entries
									</caption>
									<nav v-if="serviceRows.length && servicePagination.length" class="mt-2 float-end">
										<ul class="pagination pagination-sm mb-0">
											<li
												class="page-item"
												v-bind:class="[{ disabled: !p.url }, { active: p.active }]"
												v-for="(p, idx) in servicePagination"
												:key="'sp-' + idx"
											>
												<a class="page-link" href="#" @click.prevent="onServicePageClick(p)">
													<span v-if="idx === 0">Prev</span>
													<span v-else-if="idx === servicePagination.length - 1">Next</span>
													<span v-else>{{ p.label }}</span>
												</a>
											</li>
										</ul>
									</nav>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "UserDues",
	data() {
		return {
			token: "",
			user_id: "",
			renewal_limit: 10,
			renewal_keyword: "",
			service_limit: 10,
			service_keyword: "",
			renewalRows: [],
			renewalPagination: [],
			renewalFrom: 0,
			renewalTo: 0,
			renewalTotal: 0,
			serviceRows: [],
			servicePagination: [],
			serviceFrom: 0,
			serviceTo: 0,
			serviceTotal: 0,
			totalRenewalPendingAmount: "0.00",
			totalServicePendingAmount: 0,
			summaryUserName: "",
			summaryPaymentUserType: null,
			renewalPage: 1,
			servicePage: 1,
			renewalSearchTimer: null,
			serviceSearchTimer: null,
		};
	},
	created() {
		this.user_id = this.$route?.params?.id || this.$route?.query?.user_id || "";
		this.fetchPendingPayments();
	},
	watch: {
		"$route.params.id"(val) {
			this.user_id = val || "";
			this.renewalPage = 1;
			this.servicePage = 1;
			this.fetchPendingPayments();
		},
	},
	methods: {
		getToken() {
			if (localStorage.getItem("airotrack_staff")) {
				const airotrack_staff = JSON.parse(localStorage.getItem("airotrack_staff"));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		buildParams() {
			const params = {
				user_id: this.user_id,
				renewal_limit: this.renewal_limit,
				renewal_keyword: this.renewal_keyword || "",
				service_limit: this.service_limit,
				service_keyword: this.service_keyword || "",
			};
			if (this.renewalPage > 1) params.page = this.renewalPage;
			if (this.servicePage > 1) params.service_page = this.servicePage;
			return params;
		},

		fetchPendingPayments() {
			if (!this.user_id) {
				this.clearData();
				return;
			}
			this.getToken();
			this.$axios
				.get("/staffs/userPendingPayments", {
					params: this.buildParams(),
					headers: { Authorization: "Bearer " + this.token },
				})
				.then((res) => {
					const ok = res.data.status === "true" || res.data.status === true;
					if (!ok) {
						this.clearData();
						return;
					}
					const d = res.data.data || {};
					this.totalRenewalPendingAmount = d.totalRenewalPendingAmount ?? "0.00";
					this.totalServicePendingAmount = d.totalServicePendingAmount ?? 0;

					const rPag = d.renewalPendingPayments;
					this.renewalRows = rPag?.data || [];
					this.renewalPagination = rPag?.links || [];
					this.renewalFrom = rPag?.from ?? 0;
					this.renewalTo = rPag?.to ?? 0;
					this.renewalTotal = rPag?.total ?? 0;
					if (rPag?.current_page) this.renewalPage = rPag.current_page;

					const sPag = d.servicePendingPayments || {};
					this.serviceRows = sPag.data || [];
					this.servicePagination = sPag.links || [];
					this.serviceFrom = sPag.from ?? 0;
					this.serviceTo = sPag.to ?? 0;
					this.serviceTotal = sPag.total ?? 0;
					if (sPag.current_page) this.servicePage = sPag.current_page;

					const firstRenewal = this.renewalRows[0];
					const firstService = this.serviceRows[0];
					const src = firstRenewal || firstService;
					this.summaryUserName = src?.user_name || "";
					this.summaryPaymentUserType =
						src?.payment_user_type !== undefined && src?.payment_user_type !== null
							? src.payment_user_type
							: null;
				})
				.catch((err) => {
					console.error(err);
					this.$swal("Error", err.response?.data?.message || "Failed to load pending payments", "error");
					this.clearData();
				});
		},

		clearData() {
			this.renewalRows = [];
			this.renewalPagination = [];
			this.serviceRows = [];
			this.servicePagination = [];
			this.totalRenewalPendingAmount = "0.00";
			this.totalServicePendingAmount = 0;
			this.summaryUserName = "";
			this.summaryPaymentUserType = null;
		},

		onRenewalLimitChange() {
			this.renewalPage = 1;
			this.fetchPendingPayments();
		},
		onServiceLimitChange() {
			this.servicePage = 1;
			this.fetchPendingPayments();
		},

		debouncedFetchRenewal() {
			if (this.renewalSearchTimer) clearTimeout(this.renewalSearchTimer);
			this.renewalSearchTimer = setTimeout(() => {
				this.renewalPage = 1;
				this.fetchPendingPayments();
			}, 400);
		},
		debouncedFetchService() {
			if (this.serviceSearchTimer) clearTimeout(this.serviceSearchTimer);
			this.serviceSearchTimer = setTimeout(() => {
				this.servicePage = 1;
				this.fetchPendingPayments();
			}, 400);
		},

		parseRenewalPageFromUrl(url) {
			if (!url) return null;
			let m = /[?&]renewal_page=(\d+)/.exec(url);
			if (m) return parseInt(m[1], 10);
			m = /[?&]page=(\d+)/.exec(url);
			return m ? parseInt(m[1], 10) : null;
		},
		parseServicePageFromUrl(url) {
			if (!url) return null;
			let m = /[?&]service_page=(\d+)/.exec(url);
			if (m) return parseInt(m[1], 10);
			m = /[?&]page=(\d+)/.exec(url);
			return m ? parseInt(m[1], 10) : null;
		},

		onRenewalPageClick(p) {
			if (!p.url) return;
			const pg = this.parseRenewalPageFromUrl(p.url);
			if (pg == null) return;
			this.renewalPage = pg;
			this.fetchPendingPayments();
		},
		onServicePageClick(p) {
			if (!p.url) return;
			const pg = this.parseServicePageFromUrl(p.url);
			if (pg == null) return;
			this.servicePage = pg;
			this.fetchPendingPayments();
		},

		formatMoney(value) {
			const n = parseFloat(value);
			if (isNaN(n)) return "0.00";
			return n.toFixed(2);
		},

		paymentTypeLabel(v) {
			const map = { 1: "Cash", 2: "Online", 3: "Both", 4: "Credit" };
			return map[Number(v)] || "—";
		},
		paymentStatusLabel(v) {
			const map = { 1: "Received", 2: "Pending", 3: "Partially", 4: "Credit" };
			return map[Number(v)] || "—";
		},
		paymentStatusClass(v) {
			const n = Number(v);
			if (n === 1) return "bg-success";
			if (n === 2) return "bg-warning text-dark";
			if (n === 3) return "bg-info text-dark";
			if (n === 4) return "bg-secondary";
			return "bg-light text-dark";
		},
		deductCreditLabel(v) {
			if (v == 1) return "Yes";
			if (v == 2) return "No";
			return "—";
		},
	},
};
</script>
